var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCandidates = function SvgCandidates(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: 96,
    height: 96,
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "multiple 11")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#9BCED3",
    cx: 39,
    cy: 10,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9BCED3",
    cx: 9,
    cy: 10,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#76B5B5",
    d: "M35.9966888,17C33.2370911,17,31,19.2295895,31,22.0038109 v6.7917995c0,0.5547104,0.4171391,1.1712494,0.9327698,1.3774986L34,31l0.9164581,10.9975281 C34.9626007,42.551178,35.4530411,43,35.9970284,43h6.0059433c0.5506401,0,1.0350075-0.455761,1.0805702-1.0024719L44,31 l2.0507812-0.6835899C46.5750198,30.1416607,47,29.5525093,47,29.0014992v-6.9939594C47,19.2419491,44.758419,17,42.0033112,17 H35.9966888z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#76B5B5",
    d: "M5.996686,17C3.237092,17,1,19.2295895,1,22.0038109v6.7917995 c0,0.5547104,0.4171371,1.1712494,0.9327741,1.3774986L4,31l0.916461,10.9975281C4.9625978,42.551178,5.4530358,43,5.9970298,43 h6.00594c0.5506401,0,1.0350103-0.455761,1.0805702-1.0024719L14,31l2.0507812-0.6835899 C16.5750198,30.1416607,17,29.5525093,17,29.0014992v-6.9939594C17,19.2419491,14.75842,17,12.0033102,17H5.996686z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5A7A84",
    cx: 24,
    cy: 7,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#335262",
    d: "M20.0006599,15C16.6865902,15,14,17.6780396,14,21.0033302v8.9958 c0,0.5527592,0.39816,1.1999512,0.8877296,1.4447289L18,33l1.0039997,13.0830002C19.0470009,46.6020012,19.4790001,47,20,47h8 c0.5209999,0,0.9529991-0.3979988,0.9960003-0.9169998l0.941-13.2870026l3.1410408-1.3884583 C33.5872307,31.1824608,34,30.5553703,34,29.9991302v-8.9958C34,17.6877804,31.3234596,15,27.9993401,15H20.0006599z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCandidates, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/candidates.7f782e39.svg";
export { ForwardRef as ReactComponent };